(function () {
  if (!svgedit.recalculate) {
    svgedit.recalculate = {};
  }

  const NS = svgedit.NS;
  let context_;

  svgedit.recalculate.init = function (editorContext) {
    context_ = editorContext;
  };

  svgedit.recalculate.cloneTransfromList = function (src, dest) {
    const srcTList = svgedit.transformlist.getTransformList(src);
    const destTList = svgedit.transformlist.getTransformList(dest);
    const stringTransforms = getStringTransforms(src.getAttribute('transform'));

    destTList.clear();

    for (let i = 0; i < srcTList.numberOfItems; i++) {
      destTList.appendItem(svgedit.recalculate.cloneTransfrom(srcTList.getItem(i), stringTransforms[i]));
    }

    function getStringTransforms (transform) {
      return transform ? transform.match(/((matrix|translate|rotate|scale|skewX|skewY)\([^\)]*\))\s*,?\s*/ig) : [];
    }
  };

  svgedit.recalculate.cloneTransfrom = function (transform, stringTransform) {
    const clone = svgroot.createSVGTransform();
    const matrixParts = decomposeMatrix(transform.matrix);

    switch (transform.type) {
      case 0:
      case 1: clone.setMatrix(transform.matrix); break;
      case 2: clone.setTranslate(matrixParts.translateX, matrixParts.translateY); break;
      case 3: clone.setScale(matrixParts.scaleX, matrixParts.scaleY); break;

      case 4:
        var regexp = /rotate\(([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?),? ?([+-]?\d+(\.\d+)?)\)/gi;
        var res = regexp.exec(stringTransform);

        var cx = res ? res[3] : 0;
        var cy = res ? res[5] : 0;

        clone.setRotate(matrixParts.rotation, cx, cy);
        break;

      case 5: clone.setSkewX(matrixParts.skewX); break;
      case 6: clone.setSkewY(matrixParts.skewY);
    }

    return clone;

    function decomposeMatrix (matrix) {
      const px = deltaTransformPoint(matrix, { x: 0, y: 1 });
      const py = deltaTransformPoint(matrix, { x: 1, y: 0 });

      const skewX = ((180 / Math.PI) * Math.atan2(px.y, px.x) - 90);
      const skewY = ((180 / Math.PI) * Math.atan2(py.y, py.x));

      return {
        translateX: matrix.e,
        translateY: matrix.f,
        scaleX: Math.sqrt(matrix.a * matrix.a + matrix.b * matrix.b),
        scaleY: Math.sqrt(matrix.c * matrix.c + matrix.d * matrix.d),
        skewX,
        skewY,
        rotation: skewX
      };
    }

    function deltaTransformPoint (matrix, point) {
      const dx = point.x * matrix.a + point.y * matrix.c + 0;
      const dy = point.x * matrix.b + point.y * matrix.d + 0;
      return { x: dx, y: dy };
    }
  };

  svgedit.recalculate.updateClipPath = function (elem) {
    svgedit.recalculate.recalculateDimensions(elem);
  };

  svgedit.recalculate.recalculateDimensions = function (selected) {
    let retval;
    if (selected == null) {
      return null;
    }

    const $selected = $(selected);
    // Firefox Issue - 1081
    if (selected.nodeName == 'svg' && navigator.userAgent.indexOf('Firefox/20') >= 0) {
      return null;
    }

    if ($selected.is('.textarea')) {
      svgedit.transformlist.removeElementFromListMap(selected);
    }

    const svgCanvas = INKIVE.Tool && INKIVE.Tool.getInstance().editor.canvas;
    const tlist = svgedit.transformlist.getTransformList(selected);
    if (!tlist) return null;

    const N = tlist.numberOfItems;

    // scale
    const is3TransformsScale = N >= 3 &&
    tlist.getItem(N - 2).type === SVGTransform.SVG_TRANSFORM_SCALE &&
    tlist.getItem(N - 3).type === SVGTransform.SVG_TRANSFORM_TRANSLATE &&
    tlist.getItem(N - 1).type === SVGTransform.SVG_TRANSFORM_TRANSLATE;

    const is2TransformsScale = N === 2 &&
    tlist.getItem(N - 2).type === SVGTransform.SVG_TRANSFORM_TRANSLATE &&
    tlist.getItem(N - 1).type === SVGTransform.SVG_TRANSFORM_SCALE;

    if ($selected.is('.textarea') && (is3TransformsScale || is2TransformsScale)) {
      if (is3TransformsScale || is2TransformsScale) {
        let xform = null;
        let xformIndex = 0;

        for (xformIndex; xformIndex < N; ++xformIndex) {
          xform = tlist.getItem(xformIndex);
          if (xform.type === SVGTransform.SVG_TRANSFORM_ROTATE) {
            break;
          } else {
            xform = null;
          }
        }

        xform && tlist.removeItem(xformIndex);

        const scale = svgedit.math.transformListToTransform(tlist, 0, 2).matrix.a;
        const isTableCell = selected.parentElement?.classList?.contains('table-cell');

        retval = svgedit.recalculate._recalculateDimensions(selected);

        svgCanvas && svgCanvas.runExtensions('resizeText', {
          elem: selected,
          isTableCell,
          scale
        });

        xform && tlist.appendItem(xform);

        return retval;
      }
    } else if (is2TransformsScale) {
      $selected.is('image') && recalcultateFlippedImage();
      $selected.is('.text') && recalcultateFlippedText();
    }

    const main = $('#svgcontent .main').get(0);
    const shouldUpdateClipPath = selected.getAttribute('clip-path') || $(selected).is('.layoutBox:not(.non-selectable)');
    const clipPathInitialPosition = shouldUpdateClipPath && getClipPathSource();

    retval = svgedit.recalculate._recalculateDimensions(selected);

    clipPathInitialPosition && recalculateClipPath();

    if (svgCanvas &&
      $(selected).hasClass('layoutBox') &&
      (main && $.contains(main, selected)) &&
      svgCanvas.runExtensions('isEmptyLayout', { layoutBox: selected })
    ) {
      svgCanvas.runExtensions('setFullSizePlaceholder', { layoutBox: selected });
    } else {
      $(selected).hasClass('layoutClipperImage') && recalculateClipper();
    }

    return retval;

    function recalculateClipper () {
      const layoutScreen = $(selected).siblings('#layoutScreen');
      layoutScreen.length && svgedit.recalculate._recalculateDimensions(layoutScreen[0]);
    }

    function getClipPathSource () {
      const clipPath = svgedit.utilities.getClipPath(selected);

      if (clipPath) {
        const clipPathBbox = svgedit.utilities.getBBox(clipPath);
        const imageBbox = selected.getBBox();

        return {
          xOffset: (clipPathBbox.x - imageBbox.x) / imageBbox.width,
          yOffset: (clipPathBbox.y - imageBbox.y) / imageBbox.height,
          widthScale: clipPathBbox.width / imageBbox.width,
          heightScale: clipPathBbox.height / imageBbox.height
        };
      }
    }

    function recalculateClipPath () {
      const clipPath = svgedit.utilities.getClipPath(selected);
      const imageBbox = selected.getBBox();
      const svgroot = context_.getSVGRoot();

      const nx = imageBbox.x + imageBbox.width * clipPathInitialPosition.xOffset;
      const ny = imageBbox.y + imageBbox.height * clipPathInitialPosition.yOffset;

      const nw = imageBbox.width * clipPathInitialPosition.widthScale;
      const nh = imageBbox.height * clipPathInitialPosition.heightScale;

      if (isNaN(nw) || isNaN(nh) || !imageBbox.width || !imageBbox.height) return;

      _.each(clipPath.childNodes, function (shape) {
        let clipPathBbox = svgedit.utilities.getBBox(clipPath);
        let tlist = svgedit.transformlist.getTransformList(shape);
        const scale = svgroot.createSVGTransform();
        const translate = svgroot.createSVGTransform();

        if (clipPathBbox && clipPathBbox.width > 0 && clipPathBbox.height > 0 && nw && nh) {
          scale.setScale(nw / clipPathBbox.width, nh / clipPathBbox.height);
          tlist.appendItem(scale);
          svgedit.recalculate.recalculateDimensions(shape);

          clipPathBbox = svgedit.utilities.getBBox(clipPath);
          tlist = svgedit.transformlist.getTransformList(shape);
          translate.setTranslate(nx - clipPathBbox.x, ny - clipPathBbox.y);
          tlist.appendItem(translate);
          svgedit.recalculate.recalculateDimensions(shape);
        }
      });

      if (selected.classList.contains('layoutBox')) {
        $(document).trigger('editor.runExtensions', {
          name: 'setLayoutBoxCoord',
          data: {
            layoutBox: selected,
            bbox: svgedit.utilities.getBBox(clipPath)
          }
        });
      }
    }

    function recalcultateFlippedImage () {
      const xformScale = tlist.getItem(N - 1);
      const xformTranslate = tlist.getItem(N - 2);

      let translateX = xformTranslate.matrix.e;
      let translateY = xformTranslate.matrix.f;
      const scaleX = xformScale.matrix.a;
      const scaleY = xformScale.matrix.d;

      for (let i = tlist.numberOfItems - 1; i >= 0; i--) {
        tlist.removeItem(i);
      }

      if (scaleX === -1) {
        $(selected).addClass(INKIVE.C.FLIP_IMAGE.HORIZONTAL);
        translateX = 0;
      }

      if (scaleY === -1) {
        $(selected).addClass(INKIVE.C.FLIP_IMAGE.VERTICAL);
        translateY = 0;
      }

      if (translateX || translateY) {
        xformTranslate.setTranslate(translateX, translateY);
        tlist.appendItem(xformTranslate);
      }

      const selectedClipPath = svgedit.utilities.getClipPath(selected);

      selectedClipPath && _.each(selectedClipPath.childNodes, function (shape) {
        const shapeTlist = svgedit.transformlist.getTransformList(shape);

        for (let i = shapeTlist.numberOfItems - 1; i >= 0; i--) {
          shapeTlist.removeItem(i);
        }

        (translateX || translateY) && shapeTlist.appendItem(xformTranslate);
      });
    }

    function recalcultateFlippedText () {
      const xformScale = tlist.getItem(N - 1);
      const scaleX = xformScale.matrix.a;
      const scaleY = xformScale.matrix.d;
      const bbox = selected.getBBox();
      const height = $selected.attr('font-size') || bbox.height;

      if (scaleX === -1 && scaleY === -1) {
        for (let i = tlist.numberOfItems - 1; i >= 0; i--) {
          tlist.removeItem(i);
        }

        const textArea = $selected.parents('.textarea')[0];
        const textareaTlist = svgedit.transformlist.getTransformList(textArea);
        const R_nc = svgroot.createSVGTransform();

        R_nc.setRotate(180, bbox.x, bbox.y + height);
        textareaTlist.appendItem(R_nc);
      }
    }
  };

  // Function: svgedit.recalculate.recalculateDimensions
  // Decides the course of action based on the element's transform list
  //
  // Parameters:
  // selected - The DOM element to recalculate
  //
  // Returns:
  // Undo command object with the resulting change
  svgedit.recalculate._recalculateDimensions = function (selected) {
  // we know we have some transforms, so set up return variable
    const batchCmd = new svgedit.history.BatchCommand('Transform');
    const svgroot = context_.getSVGRoot();
    const tlist = svgedit.transformlist.getTransformList(selected);

    $(selected).trigger('change');

    let k;
    // remove any unnecessary transforms
    if (tlist && tlist.numberOfItems > 0) {
      k = tlist.numberOfItems;
      while (k--) {
        var xform = tlist.getItem(k);
        if (xform.type === 0) {
          tlist.removeItem(k);
        }
        // remove identity matrices
        else if (xform.type === 1) {
          if (svgedit.math.isIdentity(xform.matrix)) {
            tlist.removeItem(k);
          }
        }
        // remove zero-degree rotations
        else if (xform.type === 4) {
          if (xform.angle === 0) {
            tlist.removeItem(k);
          }
        }
      }
      // End here if all it has is a rotation
      if (tlist.numberOfItems === 1 &&
      svgedit.utilities.getRotationAngle(selected)) {
        return null;
      }
    }

    // if this element had no transforms, we are done
    if (!tlist || tlist.numberOfItems == 0) {
    // Chrome has a bug that requires clearing the attribute first.
      selected.setAttribute('transform', '');
      selected.removeAttribute('transform');
      return null;
    }

    // TODO: Make this work for more than 2
    if (tlist) {
      k = tlist.numberOfItems;
      let mxs = [];
      while (k--) {
        var xform = tlist.getItem(k);
        if (xform.type === 1) {
          mxs.push([xform.matrix, k]);
        } else if (mxs.length) {
          mxs = [];
        }
      }
      if (mxs.length === 2) {
        const m_new = svgroot.createSVGTransformFromMatrix(svgedit.math.matrixMultiply(mxs[1][0], mxs[0][0]));
        tlist.removeItem(mxs[0][1]);
        tlist.removeItem(mxs[1][1]);
        tlist.insertItemBefore(m_new, mxs[1][1]);
      }

      // combine matrix + translate
      k = tlist.numberOfItems;
      if (k >= 2 && tlist.getItem(k - 2).type === 1 && tlist.getItem(k - 1).type === 2) {
        const mt = svgroot.createSVGTransform();

        const m = svgedit.math.matrixMultiply(
          tlist.getItem(k - 2).matrix,
          tlist.getItem(k - 1).matrix);
        mt.setMatrix(m);
        tlist.removeItem(k - 2);
        tlist.removeItem(k - 2);
        tlist.appendItem(mt);
      }
    }

    // If it still has a single [M] or [R][M], return null too (prevents BatchCommand from being returned).
    switch (selected.tagName) {
    // Ignore these elements, as they can absorb the [M]
      case 'line':
      case 'polyline':
      case 'polygon':
      case 'path':
        break;
      default:
        if ((tlist.numberOfItems === 1 && tlist.getItem(0).type === 1) ||
        (tlist.numberOfItems === 2 && tlist.getItem(0).type === 1 && tlist.getItem(0).type === 4)) {
          return null;
        }
    }

    // Grouped SVG element
    const gsvg = $(selected).data('gsvg');

    // store initial values that will be affected by reducing the transform list
    let changes = {};
    let initial = null;
    let attrs = [];
    switch (selected.tagName) {
      case 'line':
        attrs = ['x1', 'y1', 'x2', 'y2'];
        break;
      case 'circle':
        attrs = ['cx', 'cy', 'r'];
        break;
      case 'ellipse':
        attrs = ['cx', 'cy', 'rx', 'ry'];
        break;
      case 'foreignObject':
      case 'rect':
      case 'image':
        attrs = ['width', 'height', 'x', 'y'];
        break;
      case 'use':
      case 'text':
      case 'tspan':
        attrs = ['x', 'y'];
        break;
      case 'polygon':
      case 'polyline':
        initial = {};
        initial.points = selected.getAttribute('points');
        var list = selected.points;
        var len = list.numberOfItems;
        changes.points = new Array(len);
        var i;
        for (i = 0; i < len; ++i) {
          const pt = list.getItem(i);
          changes.points[i] = {
            x: pt.x,
            y: pt.y
          };
        }
        break;
      case 'path':
        initial = {};
        initial.d = selected.getAttribute('d');
        changes.d = selected.getAttribute('d');
        break;
    } // switch on element type to get initial values

    if (attrs.length) {
      changes = $(selected).attr(attrs);
      $.each(changes, function (attr, val) {
        changes[attr] = svgedit.units.convertToNum(attr, val);
      });
    } else if (gsvg) {
    // GSVG exception
      changes = {
        x: $(gsvg).attr('x') || 0,
        y: $(gsvg).attr('y') || 0
      };
    }

    // if we haven't created an initial array in polygon/polyline/path, then
    // make a copy of initial values and include the transform
    if (initial == null) {
      initial = $.extend(true, {}, changes);
      $.each(initial, function (attr, val) {
        if (isNaN(val)) val = 0;
        initial[attr] = svgedit.units.convertToNum(attr, val);
      });
    }
    // save the start transform value too
    initial.transform = context_.getStartTransform() || '';

    const isGroup = isGroupTransform();

    const success = isGroup
      ? processGroupTransform()
      : processNonGroupTransform();
    if (!success) return;

    tlist.numberOfItems || selected.removeAttribute('transform');
    batchCmd.addSubCommand(new svgedit.history.ChangeElementCommand(selected, initial));

    return batchCmd;

    function isGroupTransform () {
      return (selected.tagName == 'g' && !gsvg) || selected.tagName == 'a';
    }

    function processGroupTransform () {
      const box = svgedit.utilities.getBBox(selected);

      const oldcenter = {
        x: box.x + box.width / 2,
        y: box.y + box.height / 2
      };
      let newcenter = svgedit.math.transformPoint(box.x + box.width / 2,
        box.y + box.height / 2,
        svgedit.math.transformListToTransform(tlist).matrix);
      let m = svgroot.createSVGMatrix();

      // temporarily strip off the rotate and save the old center
      const gangle = svgedit.utilities.getRotationAngle(selected);
      if (gangle) {
        const a = gangle * Math.PI / 180;
        if (Math.abs(a) > (1.0e-10)) {
          var s = Math.sin(a) / (1 - Math.cos(a));
        } else {
        // FIXME: This blows up if the angle is exactly 0!
          var s = 2 / a;
        }
        let i;
        for (i = 0; i < tlist.numberOfItems; ++i) {
          const xform = tlist.getItem(i);
          if (xform.type == 4) {
          // extract old center through mystical arts
            const rm = xform.matrix;
            oldcenter.y = (s * rm.e + rm.f) / 2;
            oldcenter.x = (rm.e - s * rm.f) / 2;
            tlist.removeItem(i);
            break;
          }
        }
      }
      let tx = 0;
      let ty = 0;
      let operation = 0;
      const N = tlist.numberOfItems;

      if (N) {
        var first_m = tlist.getItem(0).matrix;
      }

      // first, if it was a scale then the second-last transform will be it
      if (N >= 3 && tlist.getItem(N - 2).type === 3 &&
      tlist.getItem(N - 3).type === 2 && tlist.getItem(N - 1).type === 2) {
        operation = 3; // scale

        // if the children are unrotated, pass the scale down directly
        // otherwise pass the equivalent matrix() down directly
        var tm = tlist.getItem(N - 3).matrix;
        var sm = tlist.getItem(N - 2).matrix;
        var tmn = tlist.getItem(N - 1).matrix;

        var children = selected.childNodes;
        var c = children.length;
        while (c--) {
          var child = children.item(c);
          tx = 0;
          ty = 0;
          if (child.nodeType === 1) {
            var childTlist = svgedit.transformlist.getTransformList(child);

            // some children might not have a transform (<metadata>, <defs>, etc)
            if (!childTlist) { continue; }

            m = svgedit.math.transformListToTransform(childTlist).matrix;

            const angle = svgedit.utilities.getRotationAngle(child);
            var oldStartTransform = context_.getStartTransform();
            var childxforms = [];
            context_.setStartTransform(child.getAttribute('transform'));
            if (angle || svgedit.math.hasMatrixTransform(childTlist)) {
              var e2t = svgroot.createSVGTransform();
              e2t.setMatrix(svgedit.math.matrixMultiply(tm, sm, tmn, m));
              childTlist.clear();
              childTlist.appendItem(e2t);
              childxforms.push(e2t);
            }
            // if not rotated or skewed, push the [T][S][-T] down to the child
            else {
            // update the transform list with translate,scale,translate

              // slide the [T][S][-T] from the front to the back
              // [T][S][-T][M] = [M][T2][S2][-T2]

              // (only bringing [-T] to the right of [M])
              // [T][S][-T][M] = [T][S][M][-T2]
              // [-T2] = [M_inv][-T][M]
              var t2n = svgedit.math.matrixMultiply(m.inverse(), tmn, m);
              // [T2] is always negative translation of [-T2]
              var t2 = svgroot.createSVGMatrix();
              t2.e = -t2n.e;
              t2.f = -t2n.f;

              // [T][S][-T][M] = [M][T2][S2][-T2]
              // [S2] = [T2_inv][M_inv][T][S][-T][M][-T2_inv]
              var s2 = svgedit.math.matrixMultiply(t2.inverse(), m.inverse(), tm, sm, tmn, m, t2n.inverse());

              var translateOrigin = svgroot.createSVGTransform();
              var scale = svgroot.createSVGTransform();
              var translateBack = svgroot.createSVGTransform();
              translateOrigin.setTranslate(t2n.e, t2n.f);
              scale.setScale(s2.a, s2.d);
              translateBack.setTranslate(t2.e, t2.f);
              childTlist.appendItem(translateBack);
              childTlist.appendItem(scale);
              childTlist.appendItem(translateOrigin);
              childxforms.push(translateBack);
              childxforms.push(scale);
              childxforms.push(translateOrigin);
            } // not rotated
            batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(child));

            context_.setStartTransform(oldStartTransform);
          } // element
        } // for each child
        // Remove these transforms from group
        tlist.removeItem(N - 1);
        tlist.removeItem(N - 2);
        tlist.removeItem(N - 3);
      } else if (N >= 3 && tlist.getItem(N - 1).type === 1) {
        operation = 3; // scale
        m = svgedit.math.transformListToTransform(tlist).matrix;
        var e2t = svgroot.createSVGTransform();
        e2t.setMatrix(m);
        tlist.clear();
        tlist.appendItem(e2t);
      }
      // next, check if the first transform was a translate
      // if we had [ T1 ] [ M ] we want to transform this into [ M ] [ T2 ]
      // therefore [ T2 ] = [ M_inv ] [ T1 ] [ M ]
      else if ((N === 1 || (N > 1 && tlist.getItem(1).type !== 3)) &&
      tlist.getItem(0).type === 2) {
        operation = 2; // translate
        const T_M = svgedit.math.transformListToTransform(tlist).matrix;
        tlist.removeItem(0);
        const M_inv = svgedit.math.transformListToTransform(tlist).matrix.inverse();
        const M2 = svgedit.math.matrixMultiply(M_inv, T_M);

        tx = M2.e;
        ty = M2.f;

        if (tx !== 0 || ty !== 0) {
        // we pass the translates down to the individual children
          var children = selected.childNodes;
          var c = children.length;

          let clipPaths_done = [];

          while (c--) {
            var child = children.item(c);
            if (child.nodeType == 1) {
            // Check if child has clip-path
              if (child.getAttribute('clip-path')) {
              // tx, ty
                const attr = child.getAttribute('clip-path');
                if (clipPaths_done.indexOf(attr) === -1) {
                  svgedit.recalculate.updateClipPath(child);
                  clipPaths_done.push(attr);
                }
              }

              var oldStartTransform = context_.getStartTransform();
              context_.setStartTransform(child.getAttribute('transform'));

              var childTlist = svgedit.transformlist.getTransformList(child);
              // some children might not have a transform (<metadata>, <defs>, etc)
              if (childTlist) {
                var newxlate = svgroot.createSVGTransform();
                newxlate.setTranslate(tx, ty);
                if (childTlist.numberOfItems) {
                  childTlist.insertItemBefore(newxlate, 0);
                } else {
                  childTlist.appendItem(newxlate);
                }
                batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(child));
                // If any <use> have this group as a parent and are
                // referencing this child, then impose a reverse translate on it
                // so that when it won't get double-translated
                const uses = selected.getElementsByTagNameNS(NS.SVG, 'use');
                const href = '#' + child.id;
                let u = uses.length;
                while (u--) {
                  const useElem = uses.item(u);
                  if (href == svgedit.utilities.getHref(useElem)) {
                    const usexlate = svgroot.createSVGTransform();
                    usexlate.setTranslate(-tx, -ty);
                    svgedit.transformlist.getTransformList(useElem).insertItemBefore(usexlate, 0);
                    batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(useElem));
                  }
                }
                context_.setStartTransform(oldStartTransform);
              }
            }
          }

          clipPaths_done = [];
          context_.setStartTransform(oldStartTransform);
        }
      }
      // else, a matrix imposition from a parent group
      // keep pushing it down to the children
      else if (N === 1 && tlist.getItem(0).type === 1 && !gangle) {
        operation = 1;
        m = tlist.getItem(0).matrix;

        var children = selected.childNodes;
        var c = children.length;

        while (c--) {
          var child = children.item(c);

          if (child.nodeType === 1) {
            var oldStartTransform = context_.getStartTransform();
            context_.setStartTransform(child.getAttribute('transform'));
            var childTlist = svgedit.transformlist.getTransformList(child);

            if (!childTlist) { continue; }

            const em = svgedit.math.matrixMultiply(m, svgedit.math.transformListToTransform(childTlist).matrix);
            const e2m = svgroot.createSVGTransform();

            e2m.setMatrix(em);
            childTlist.clear();
            childTlist.appendItem(e2m, 0);

            batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(child));
            context_.setStartTransform(oldStartTransform);

            convertStroke(child, em);
          }
        }

        tlist.clear();
      } else if (N >= 2 && tlist.getItem(N - 2).type == 2 && tlist.getItem(N - 1).type == 3) {
        operation = 3; // scale

        var tm = tlist.getItem(N - 2).matrix;
        var sm = tlist.getItem(N - 1).matrix;
        var tmn = tlist.getItem(N - 2).matrix;

        var children = selected.childNodes;
        var c = children.length;
        while (c--) {
          var child = children.item(c);
          tx = 0;
          ty = 0;

          if (child.nodeType == 1) {
            var childTlist = svgedit.transformlist.getTransformList(child);
            if (!childTlist) continue;

            m = svgedit.math.transformListToTransform(childTlist).matrix;

            var oldStartTransform = context_.getStartTransform();
            var childxforms = [];
            context_.setStartTransform(child.getAttribute('transform'));

            var t2n = svgedit.math.matrixMultiply(m.inverse(), tmn, m);
            var t2 = svgroot.createSVGMatrix();

            t2.e = -t2n.e;
            t2.f = -t2n.f;

            var s2 = svgedit.math.matrixMultiply(t2.inverse(), m.inverse(), tm, sm, tmn, m, t2n.inverse());
            var translateOrigin = svgroot.createSVGTransform();
            var scale = svgroot.createSVGTransform();
            var translateBack = svgroot.createSVGTransform();

            translateOrigin.setTranslate(t2n.e, t2n.f);
            scale.setScale(s2.a, s2.d);
            translateBack.setTranslate(t2.e, t2.f);

            childTlist.appendItem(translateBack);
            childTlist.appendItem(scale);
            childTlist.appendItem(translateOrigin);

            childxforms.push(translateBack);
            childxforms.push(scale);
            childxforms.push(translateOrigin);

            batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(child));
            context_.setStartTransform(oldStartTransform);
          }
        }

        tlist.removeItem(N - 1);
        tlist.removeItem(N - 2);
      }
      // else it was just a rotate
      else {
        if (gangle) {
          var newRot = svgroot.createSVGTransform();
          newRot.setRotate(gangle, newcenter.x, newcenter.y);
          if (tlist.numberOfItems) {
            tlist.insertItemBefore(newRot, 0);
          } else {
            tlist.appendItem(newRot);
          }
        }
        if (tlist.numberOfItems === 0) {
          selected.removeAttribute('transform');
        }
        return false;
      }

      // if it was a translate, put back the rotate at the new center
      if (operation === 2) {
        if (gangle) {
          newcenter = {
            x: oldcenter.x + first_m.e,
            y: oldcenter.y + first_m.f
          };

          var newRot = svgroot.createSVGTransform();
          newRot.setRotate(gangle, newcenter.x, newcenter.y);
          if (tlist.numberOfItems) {
            tlist.insertItemBefore(newRot, 0);
          } else {
            tlist.appendItem(newRot);
          }
        }
      }
      // if it was a resize
      else if (operation === 3) {
        m = svgedit.math.transformListToTransform(tlist).matrix;
        const roldt = svgroot.createSVGTransform();
        roldt.setRotate(gangle, oldcenter.x, oldcenter.y);
        const rold = roldt.matrix;
        const rnew = svgroot.createSVGTransform();
        rnew.setRotate(gangle, newcenter.x, newcenter.y);
        const rnew_inv = rnew.matrix.inverse();
        const m_inv = m.inverse();
        const extrat = svgedit.math.matrixMultiply(m_inv, rnew_inv, rold, m);

        tx = extrat.e;
        ty = extrat.f;

        if (tx !== 0 || ty !== 0) {
        // now push this transform down to the children
        // we pass the translates down to the individual children
          var children = selected.childNodes;
          var c = children.length;
          while (c--) {
            var child = children.item(c);
            if (child.nodeType === 1) {
              var oldStartTransform = context_.getStartTransform();
              context_.setStartTransform(child.getAttribute('transform'));
              var childTlist = svgedit.transformlist.getTransformList(child);
              var newxlate = svgroot.createSVGTransform();
              newxlate.setTranslate(tx, ty);
              if (childTlist.numberOfItems) {
                childTlist.insertItemBefore(newxlate, 0);
              } else {
                childTlist.appendItem(newxlate);
              }

              batchCmd.addSubCommand(svgedit.recalculate.recalculateDimensions(child));
              context_.setStartTransform(oldStartTransform);
            }
          }
        }

        if (gangle) {
          if (tlist.numberOfItems) {
            tlist.insertItemBefore(rnew, 0);
          } else {
            tlist.appendItem(rnew);
          }
        }
      }

      $(selected).is('a') &&
      $(selected).children('title').length &&
      updateLinkCoords();

      const transformedBox = svgedit.utilities.getBBox(selected);
      if (selected.dataset.boundingX && box.x) selected.dataset.boundingX = transformedBox.x;
      if (selected.dataset.boundingY && box.y) selected.dataset.boundingY = transformedBox.y;
      if (selected.dataset.boundingWidth && box.width) selected.dataset.boundingWidth = transformedBox.width;
      if (selected.dataset.boundingHeight && box.height) selected.dataset.boundingHeight = transformedBox.height;

      return true;

      function updateLinkCoords () {
        const coordsSource = $(selected).is('.video')
          ? $(selected).children('image')[0]
          : selected;
        const bbox = svgedit.utilities.getBBox(coordsSource);
        const box = $(selected).children('title')[0];

        box.textContent = Math.floor4(bbox.x) +
      ' ' + Math.floor4(bbox.y) +
      ' ' + Math.floor4(bbox.width) +
      ' ' + Math.floor4(bbox.height);
      }
    }

    function convertStroke (node, em) {
      const sw = Math.floor4(node.getAttribute('stroke-width'));
      const avg = (Math.abs(em.a) + Math.abs(em.d)) / 2;

      !isNaN(sw) && node.getAttribute('stroke') !== 'none' &&
      node.setAttribute('stroke-width', Math.round(sw * avg * 10) / 10);
    }

    function processNonGroupTransform () {
    // FIXME: box might be null for some elements (<metadata> etc), need to handle this
      const box = svgedit.utilities.getBBox(selected);

      let operation;
      // Paths (and possbly other shapes) will have no BBox while still in <defs>,
      // but we still may need to recalculate them (see issue 595).
      // TODO: Figure out how to get BBox from these elements in case they
      // have a rotation transform
      // if (!box && selected.tagName != 'path') return true;

      let m = svgroot.createSVGMatrix();
      const angle = svgedit.utilities.getRotationAngle(selected);
      const oldCenter = angle && box ? getOldCenter() : null;
      let newCenter = angle && box ? getNewCenter() : null;

      // TODO: Make this work in Webkit using svgedit.transformlist.SVGTransformList
      svgedit.browser.isWebkit() || recalculateMatrixTransform();

      let someProcess = false;
      // do { // Commented due to conflicts with snap extension
      operation = getOperationType();

      if (operation !== 'rotate') {
        svgedit.coords.remapElement(selected, changes, m);
        operation == 'translate' && putBackRotateAtNewCenter();
        operation == 'scale' && angle && recenterTranslation();
        someProcess = true;
      }
      // } while(prevNumber > tlist.numberOfItems && tlist.numberOfItems > 0);
      if (selected.dataset.boundingX && changes.x) selected.dataset.boundingX = changes.x;
      if (selected.dataset.boundingY && changes.y) selected.dataset.boundingY = changes.y;
      if (selected.dataset.boundingWidth && changes.width) selected.dataset.boundingWidth = changes.width;
      if (selected.dataset.boundingHeight && changes.height) selected.dataset.boundingHeight = changes.height;

      return someProcess;

      function getOldCenter () {
        const oldCenter = {
          x: box.x + box.width / 2,
          y: box.y + box.height / 2
        };

        const a = angle * Math.PI / 180;
        const s = Math.abs(a) > (1.0e-10)
          ? Math.sin(a) / (1 - Math.cos(a))
          : 2 / a;

        for (let i = 0; i < tlist.numberOfItems; ++i) {
          const xform = tlist.getItem(i);

          if (xform.type == 4) {
            const rm = xform.matrix;
            oldCenter.y = (s * rm.e + rm.f) / 2;
            oldCenter.x = (rm.e - s * rm.f) / 2;
            tlist.removeItem(i);
            break;
          }
        }

        return oldCenter;
      }

      function getNewCenter () {
        return svgedit.math.transformPoint(
          box.x + box.width / 2,
          box.y + box.height / 2,
          svgedit.math.transformListToTransform(tlist).matrix
        );
      }

      function recalculateMatrixTransform () {
        const fill = selected.getAttribute('fill');

        if (fill && fill.indexOf('url(') === 0) {
          const paint = svgedit.utilities.getRefElem(fill);
          let type = 'pattern';
          if (paint.tagName !== type) type = 'gradient';
          const attrVal = paint.getAttribute(type + 'Units');

          if (attrVal === 'userSpaceOnUse') {
          // Update the userSpaceOnUse element
            m = svgedit.math.transformListToTransform(tlist).matrix;
            const gtlist = svgedit.transformlist.getTransformList(paint);
            const gmatrix = svgedit.math.transformListToTransform(gtlist).matrix;
            m = svgedit.math.matrixMultiply(m, gmatrix);
            const m_str = 'matrix(' + [m.a, m.b, m.c, m.d, m.e, m.f].join(',') + ')';
            paint.setAttribute(type + 'Transform', m_str);
          }
        }
      }

      function getOperationType () {
        switch (true) {
          case isScaleOfNonSkewed() : processScaleOfNonSkewed(); return 'scale';
          case isScaleOfSkewed() : processScaleOfSkewed(); return 'scale';
          case isSimpleScale() : processSimpleScale(); return 'scale';
          case isRotatedMatrixElement() : processRotatedMatrixElement(); return 'translate';
          case isMatrixImplossion() : processMatrixImplossion(); return 'matrix';
          case isSimpleTranslate() : processSimpleTranslate(); return 'translate';
          default : processRotation(); return 'rotate';
        }
      }

      function isScaleOfNonSkewed () {
        const numberOfItems = tlist.numberOfItems;
        return numberOfItems >= 3 &&
        tlist.getItem(numberOfItems - 3).type == 2 &&
        tlist.getItem(numberOfItems - 2).type == 3 &&
        tlist.getItem(numberOfItems - 1).type == 2;
      }

      function isScaleOfSkewed () {
        const numberOfItems = tlist.numberOfItems;
        return numberOfItems == 4 &&
        tlist.getItem(numberOfItems - 1).type == 1;
      }

      function isSimpleScale () {
        const numberOfItems = tlist.numberOfItems;

        return isTranslateScaleCombination(numberOfItems) &&
        tlist.getItem(numberOfItems - 1).type === 3;
      }

      function isTranslateScaleCombination (numberOfItems) {
        let i; let item; let isTSC = true;

        for (i = 0; i < numberOfItems; i++) {
          item = tlist.getItem(numberOfItems - 1);

          if (item.type !== 3 && item.type !== 2) {
            isTSC = false;
            break;
          }
        }

        return isTSC;
      }

      function isRotatedMatrixElement () {
        const numberOfItems = tlist.numberOfItems;
        return (numberOfItems == 1 ||
          (numberOfItems > 1 && tlist.getItem(1).type != 3)
        ) && tlist.getItem(0).type == 2;
      }

      function isMatrixImplossion () {
        const numberOfItems = tlist.numberOfItems;
        return numberOfItems == 1 && tlist.getItem(0).type == 1 && !angle;
      }

      function isSimpleTranslate () {
        const numberOfItems = tlist.numberOfItems;
        return tlist.getItem(numberOfItems - 1).type == 2;
      }

      function processScaleOfNonSkewed () {
        const numberOfItems = tlist.numberOfItems;

        m = svgedit.math.transformListToTransform(
          tlist, numberOfItems - 3, numberOfItems - 1
        ).matrix;

        convertStroke(selected, tlist.getItem(numberOfItems - 2).matrix);

        tlist.removeItem(numberOfItems - 1);
        tlist.removeItem(numberOfItems - 2);
        tlist.removeItem(numberOfItems - 3);
      }

      function processScaleOfSkewed () {
        const e2t = svgroot.createSVGTransform();
        m = svgedit.math.transformListToTransform(tlist).matrix;
        const em = svgedit.math.matrixMultiply(m, svgedit.math.transformListToTransform(tlist).matrix);

        e2t.setMatrix(m);
        tlist.clear();
        tlist.appendItem(e2t);

        m = svgroot.createSVGMatrix();
      }

      function processSimpleScale () {
        const index = tlist.numberOfItems - 1;
        m = svgedit.math.transformListToTransform(tlist, index).matrix;
        convertStroke(selected, tlist.getItem(index).matrix);
        tlist.removeItem(index);
      }

      function processRotatedMatrixElement () {
        const oldxlate = tlist.getItem(0).matrix;
        const meq = svgedit.math.transformListToTransform(tlist, 1).matrix;
        const meq_inv = meq.inverse();

        m = svgedit.math.matrixMultiply(meq_inv, oldxlate, meq);
        tlist.removeItem(0);
      }

      function processMatrixImplossion () {
        m = svgedit.math.transformListToTransform(tlist).matrix;

        switch (selected.tagName) {
          case 'line':
            changes = $(selected).attr(['x1', 'y1', 'x2', 'y2']);

          case 'polyline':
          case 'polygon':
            changes.points = selected.getAttribute('points');
            if (changes.points) {
              const list = selected.points;
              const len = list.numberOfItems;
              changes.points = new Array(len);
              for (let i = 0; i < len; ++i) {
                const pt = list.getItem(i);
                changes.points[i] = {
                  x: pt.x,
                  y: pt.y
                };
              }
            }

          case 'path':
            changes.d = selected.getAttribute('d');
            operation = 1;
            tlist.clear();
            break;
        }
      }

      function processRotation () {
        if (angle) {
          const newRot = svgroot.createSVGTransform();
          newRot.setRotate(angle, newCenter.x, newCenter.y);

          tlist.numberOfItems && tlist.insertItemBefore(newRot, 0);
          tlist.numberOfItems || tlist.appendItem(newRot);
        }

        tlist.numberOfItems || selected.removeAttribute('transform');
      }

      function processSimpleTranslate () {
        const index = tlist.numberOfItems - 1;
        m = svgedit.math.transformListToTransform(tlist, index).matrix;
        tlist.removeItem(index);
      }

      function putBackRotateAtNewCenter () {
        if (angle) {
          if (!svgedit.math.hasMatrixTransform(tlist)) {
            newCenter = {
              x: oldCenter.x + m.e,
              y: oldCenter.y + m.f
            };
          }
          const newRot = svgroot.createSVGTransform();
          newRot.setRotate(angle, newCenter.x, newCenter.y);

          tlist.numberOfItems && tlist.insertItemBefore(newRot, 0);
          tlist.numberOfItems || tlist.appendItem(newRot);
        }

        // We have special processing for tspans:  Tspans are not transformable
        // but they can have x,y coordinates (sigh).  Thus, if this was a translate,
        // on a text element, also translate any tspan children.
        if (selected.tagName == 'text') {
          const children = selected.getElementsByTagName('tspan');
          let c = children.length;
          while (c--) {
            const child = children.item(c);
            if (child.tagName == 'tspan') {
              const tspanChanges = {};
              if ($(child).attr('x')) {
                tspanChanges.x = $(child).attr('x');
              }
              if ($(child).attr('y')) {
                tspanChanges.y = $(child).attr('y');
              }
              svgedit.coords.remapElement(child, tspanChanges, m);
            }
          }
        }
      }

      function recenterTranslation () {
        m = svgedit.math.transformListToTransform(tlist).matrix;

        const roldt = svgroot.createSVGTransform();
        roldt.setRotate(angle, oldCenter.x, oldCenter.y);

        const rold = roldt.matrix;
        const rnew = svgroot.createSVGTransform();
        rnew.setRotate(angle, newCenter.x, newCenter.y);

        const rnew_inv = rnew.matrix.inverse();
        const m_inv = m.inverse();
        const extrat = svgedit.math.matrixMultiply(m_inv, rnew_inv, rold, m);

        svgedit.coords.remapElement(selected, changes, extrat);
        tlist.numberOfItems && tlist.insertItemBefore(rnew, 0);
        tlist.numberOfItems || tlist.appendItem(rnew);
      }
    }
  };
})();
